import { useUserInfo } from '@/context/user-info';
import type { Article } from '@/services/app.service';
import { Helmet } from 'react-helmet-async';

export function ArticleView({ data }: { data: Article }) {
  const { userLanguage } = useUserInfo();

  const title = data.translated_content[userLanguage]?.title ?? data.title;
  const description = data.translated_content[userLanguage]?.description ?? '';
  const content = data.translated_content[userLanguage]?.body ?? data.body;

  return (
    <div className="flex-1 ml-11 font-normal">
      <Helmet>
        <title>{title} | YEGO FAQ</title>
        <meta name="description" content={description || title} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description || title} />
      </Helmet>
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: the content comes from intercom */}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}
